import {AsyncAction} from '../asyncUtilsTypes';
import {Action} from 'redux';

export enum FavoriteActions {
  ADD = 'FAVORITE/ADD',
  REMOVE = 'FAVORITE/REMOVE',
  FETCH_IDS = 'FAVORITE/FETCH_IDS',
}

export type FavoriteAction =
  | AsyncAction<FavoriteActions.ADD, void, [string]>
  | AsyncAction<FavoriteActions.REMOVE, void, [string]>
  | AsyncAction<FavoriteActions.FETCH_IDS, string[], []>
  | Action<FavoriteActions.ADD>
  | Action<FavoriteActions.REMOVE>;
